// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3taIh","text":"SelectPayment_text__1n0fP","title":"SelectPayment_title__3j2R0","btn":"SelectPayment_btn__GFuk0"};